import * as React from 'react';
import {
  Typography,
} from '@revfluence/fresh';
import { Select as FreshSelect } from '@revfluence/fresh';
import { TContentGuideline } from '@frontend/applications/TermsApp/components/BulkTerms/types/ContentGuidelines';
import {
  Select as ShadcnSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@frontend/shadcn/components/ui/select';

const { Option } = FreshSelect;
const { useCallback } = React;

interface IProps {
  contentGuidelines: Array<TContentGuideline>;
  contentGuideline: TContentGuideline;
  onUpdateContentGuideline: (contentGuideline: TContentGuideline) => void;
  showFlexUI?: boolean;
}

const SelectContentGuideline: React.FC<IProps> = React.memo((props) => {
  const {
    contentGuideline,
    contentGuidelines,
    onUpdateContentGuideline,
    showFlexUI,
  } = props;

  const handleChange = useCallback((id: number | string) => {
    const selectedId = typeof id === 'string' ? parseInt(id, 10) : id;
    const contentGuidelineSelected = contentGuidelines.find(
      (contentGuidelineItem) => contentGuidelineItem.id === selectedId,
    );
    if (contentGuidelineSelected) {
      onUpdateContentGuideline(contentGuidelineSelected);
    }
  }, [
    contentGuidelines,
    onUpdateContentGuideline,
  ]);

  const handleClick = useCallback((event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  if (showFlexUI) {
    return (
      <ShadcnSelect
        value={contentGuideline?.id?.toString()}
        onValueChange={handleChange}
      >
        <SelectTrigger className="w-[250px]" onClick={handleClick}>
          <SelectValue placeholder="Select guideline" />
        </SelectTrigger>
        <SelectContent className="z-[99999]">
          {
            contentGuidelines.map((contentGuidelineItem) => (
              <SelectItem key={contentGuidelineItem.id} value={contentGuidelineItem.id.toString()}>
                <span>{ contentGuidelineItem.label }</span>
              </SelectItem>
             ))
          }
        </SelectContent>
      </ShadcnSelect>
    );
  }

  return (
    <FreshSelect
      value={contentGuideline?.id}
      style={{ width: 250 }}
      onChange={handleChange}
      onClick={handleClick}
    >
      {
        contentGuidelines.map((contentGuidelineItem) => (
          <Option key={contentGuidelineItem.id} value={contentGuidelineItem.id}>
            <Typography.Text strong>{ contentGuidelineItem.label }</Typography.Text>
          </Option>
          ))
      }
    </FreshSelect>
  );
});

SelectContentGuideline.displayName = 'SelectContentGuideline';

export default SelectContentGuideline;
